import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { LowPerformersComponent } from './../../../../../shared/components/low-performers/low-performers.component';
import { SpiderChartComponent } from './../../../../../shared/spider-chart/spider-chart.component';
import { SegmentMatrixChartComponent } from './../../../../../shared/components/segment-matrix-chart/segment-matrix-chart.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { DateTimeAdapter, OwlDateTimeComponent, OwlDateTimeFormats, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { Spinner } from 'src/app/core/services/spinner.service';
import { InternalFilterDialogComponent } from 'src/app/shared/components/internal-filter-dialog/internal-filter-dialog.component';
import { ProcessDownloadFilesComponent } from 'src/app/shared/components/process-download-files/process-download-files.component';
import { TrendingChardDialogComponent } from 'src/app/shared/components/trending-chard-dialog/trending-chard-dialog.component';
import { Paging, RequestOption } from 'src/app/shared/model/common.model';
import { SCORECARD_CLASS } from 'src/app/shared/model/internal-filter.model';
import {
  ExternalReport, INTERNALREPORT, InternalReportModel, KPI, PerformanceScoreCard,
  PerformanceSettings, SegmentationModel, TableView
} from 'src/app/shared/model/score-card.model';
import { ExcelService } from 'src/app/shared/service/excel.service';
import { ProfileService } from 'src/app/shared/service/profile.service';
import { USERTYPE } from './../../../../../core/enums/routing-item.enum';
import { LegendDialogComponent } from './../../../../../shared/components/legend-dialog/legend-dialog.component';
import { RSP_ROLES } from './../../../../../shared/enums/admin-enum';
import { Profile } from './../../../../../shared/model/profile.model';
import { InternalReportKey, MatSelectModel, RelationShipScoreCard,
  RelationShipSettings } from './../../../../../shared/model/score-card.model';
import { ScoreCardService } from './../../../../../shared/service/score-card.service';
import {
  DISPLAY_KPI, ButtonFunction, INTERNAL_REPORT_TABLE,
        PERFORMANCES_MODEL, RELATIONSHIP_MODEL, SEGMENTATION, TableSettings, VIEW_TYPE, DISPLAY_SUSTAIN_KPI, DISPLAY_QUALITY_KPI, DISPLAY_DELIVERY_KPI, DISPLAY_COST_KPI, DISPLAY_SCORING_SEGMENT, DISPLAY_KPI_GROUP
} from './index';
import { CONDITION } from 'src/app/shared/model/scorecard-setting.model';
import { SrmService } from 'src/app/shared/service/srm.service';
import { forEach } from 'lodash';


const moment = (_moment as any).default ? (_moment as any).default : _moment;
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const MY_MOMENT_DATE_TIME_FORMATS: OwlDateTimeFormats = {
  parseInput: 'MM/YYYY',
  fullPickerInput: 'l LT',
  datePickerInput: 'MMM/YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-score-card',
  templateUrl: './score-card.component.html',
  styleUrls: ['./score-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
  ]
})
export class ScoreCardComponent implements OnInit {

  requestOption: RequestOption = new RequestOption();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('table') table: MatTable<any>;

  considerParentSupplier = true;
  isShowKperKpis = false;
  listParentSupplierGSL: any[] = [];
  timeRange = '4';
  timeRangeCopy = '4';
  startDate = new Date(1990, 0, 1);
  listCommodity: any[] = [];
  listLocation: any[] = [];
  listRegion: any[] = [];
  currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
  dateTime: FormControl;
  parentSuppliers: any[] = [];
  commodities: any[] = [];
  commoditiesCopy: any[] = [];
  locations: any[] = [];
  locationsCopy: any[] = [];
  regions: any[] = [];
  regionsCopy: any[] = [];
  listParentCompanyName: any[] = [];
  arrayLocation: any[];
  arrayCommodity: any[];
  index = 0;
  listScorecardInfo: any;
  totalSpend = '0';
  listGSLInfo: string[];
  performance = new PerformanceScoreCard(PERFORMANCES_MODEL);
  performanceData: PerformanceSettings[] = [];
  performanceSustainData: PerformanceSettings[] = [];
  performanceQualityData: PerformanceSettings[] = [];
  performanceDeliveryData: PerformanceSettings[] = [];
  performanceCostData: PerformanceSettings[] = [];
  relationship = new RelationShipScoreCard(RELATIONSHIP_MODEL);
  relationshipData: RelationShipSettings[] = [];
  segmentation = SEGMENTATION;
  isConsider: any;
  listParentName: any[] = [];
  parentNames: MatSelectModel[] = [];
  gslNumbers: any[] = [];
  parentNameGSLs: any[] = [];
  parentNameGSLsCopy: any[] = [];
  dateTimeCopy: number;
  parentNameModel: any;
  type = '';
  isTableauView = false;
  resultFilter = { value: new INTERNALREPORT([], []), data: {} as any };
  displayColumns: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  tableSettings: TableSettings[] = INTERNAL_REPORT_TABLE;
  columns = this.tableSettings.map(item => item.displayedColumns);
  groupLocationAndRegion: any[] = [];
  tableData: InternalReportModel[] = [];
  defaultALL = true;
  grids = [1];
  sortTimeoutInstance: any;
  totalResults = 0;
  lastUpdate: string;
  lastRecieptDate: number;
  parents: any[] = [];
  parentsCopy: string[] = [];
  defaultParent = false;
  profileUser: Profile;
  UserType = USERTYPE;
  totalScore = 0;
  tblHeaderPlaceHolderLeft: number = 4;
  tblHeaderPlaceHolderKPI: number = 7;
  tblHeaderPlaceHolderScoreSegment: number = 6;
  isShowKPIGroup = true;
  isShowScoreSegmentGroup = true;

  // open filter first time
  firstTime = true;

  // poReceipMonth default
  poReceiptMonthDefault: number;

  buttonInternalView: ButtonFunction[] = [
    {
      name: 'Low Performers',
      method: () => this.showLowPerformers()
    },
    {
      name: 'Spider Chart',
      method: () => this.openSpiderChart()
    },
    {
      name: 'Segment Matrix',
      method: () => this.openSegmentationMatrix()
    },
    {
      name: 'Raw Data',
      method: () => this.downloadInternalRawData()
    },
    {
      name: 'Bid List - Bot Report',
      method: () => this.downloadBotReport()
    },
    // {
    //   name: 'OTD% (Supplier Promised Date)',
    //   method: () => this.downloadOTDPromisedDate()
    // },
    // {
    //   name: 'OTD% (GE Needs Date)',
    //   method: () => this.downloadOTDNeeds()
    // },
  ];

  chartName = [];

  CONDITION = CONDITION;


  constructor(
    private scoreCardService: ScoreCardService,
    private spinner: Spinner,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private saveExcelFile: ExcelService,
    private toastr: ToastrService,
    private profileService: ProfileService,
    private srmService: SrmService
  ) {
    this.type = atob(localStorage.getItem(btoa('role'))).split(',').some(r => r === RSP_ROLES.SUPPLIER)
      ? USERTYPE.SUPPLIER_USER : USERTYPE.INTERNAL_USER;
    this.displayColumns = this.tableSettings.filter(item => item.show).map(item => item.displayedColumns);
    this.dateTime = new FormControl(moment());
  }

  async ngOnInit() {
    this.getLastUpdate();
    this.getReceiptDate();
    this.showHideScoreSegmentGroup();
    this.relationshipData = Object.values(this.relationship).filter(item => item.type === USERTYPE.SUPPLIER_USER);
    // this.performanceData = Object.values(this.performance).filter(item => item.type === USERTYPE.SUPPLIER_USER);
    this.performanceData = DISPLAY_KPI.map(item => {
      return this.performance[item];
    });
    this.performanceSustainData = DISPLAY_SUSTAIN_KPI.map(item => {
      return this.performance[item];
    });
    this.performanceQualityData = DISPLAY_QUALITY_KPI.map(item => {
      return this.performance[item];
    });
    this.performanceDeliveryData = DISPLAY_DELIVERY_KPI.map(item => {
      return this.performance[item];
    });
    this.performanceCostData = DISPLAY_COST_KPI.map(item => {
      return this.performance[item];
    });

    if (this.type === USERTYPE.SUPPLIER_USER) {
      this.profileService.getProfileUser().subscribe((info: any) => {
        this.profileUser = info.data;

        // set value and data from userInfo to Parent Company
        this.parentNames = [
          {
            name: this.profileUser.gslInfos[0].parentCompanyName,
            value: this.profileUser.gslInfos[0].parentCompanyName
          }];
        this.parents = this.parentNames;
        this.defaultParent = true;

        // set data and value from userInfo to gslNumbers
        this.gslNumbers = this.profileUser.gslInfos.map(item => ({
          name: `${item.supplierName}/${item.gslNumber}`,
          value: item.gslNumber,
          parentName: item.parentCompanyName,
          suplierName: `${item.supplierName}/${item.gslNumber}`
        }));
        this.parentNameGSLs = [...this.gslNumbers];
      });
      await this.getDataFilter();
      this.onApplyClick();
      this.isTableauView = true;
    } else {
      // this.getParentCompanyName();
      this.getParentCompanyNameAndMinorComponent();
    }
  }

  public considerParentChange(event?) {
    const search = event;
    this.scoreCardService.getGSL(search).subscribe(res => {
      let data = [];
      data = res.data.map(item => {
        const object = {
          name: `${item.parentCompanyName} / ${item.supplierName} / ${item.gslNumber}`,
          value: item.gslNumber,
          parentName: item.parentCompanyName,
          suplierName: `${item.supplierName} / ${item.gslNumber}`
        };
        return object;
      });
      // list Parent/GSL data
      this.listParentSupplierGSL = data;

      // list gslNumber of the first parent name
      // this.gslNumbers = res.data.filter(item => item.parentCompanyName === this.parentSuppliers[0])
      //   .map(el => el.gslNumber);
      if (this.type === USERTYPE.SUPPLIER_USER) {
        this.parentNameGSLs = data;
        this.getDataFilter();
      }
      this.cd.detectChanges();
    });
  }

  public timeRangeChanged() {
    this.getDataFilter();
  }

  public filterData(name, value) {
    if (name === 'parentSupplier') {
      if (this.type === USERTYPE.SUPPLIER_USER) {
        const data = value.slice();
        if (data[0] === 'All') {
          data.shift();
        }
        this.parentNameGSLs = data;
        this.getDataFilter();
      } else {
        // list parent name
        this.parentNameGSLs = value;
        this.getDataFilter();
        return;
      }
    }
    const data = value.slice();
    if (data[0] === 'All') {
      data.shift();
    }
    if (name === 'location') {
      this.locations = data;
      // this.getRegionsByLocations(this.locations);
    } else if (name === 'gslNumber') {
      this.parentNameGSLs = data;
      // this.parentNameGSLs = [];
      // const gslNumbers = data;
      // if (this.parents) {
      //   this.parents.forEach((item: MatSelectModel) => {
      //     this.parentNameGSLs.push(...gslNumbers.filter(gsl => gsl.parentName === item.value));
      //   });
      // }
      this.getDataFilter();
      return;
    } else if (name === 'commodity') {
      this.commodities = data;
    } else {
      this.regions = data;
    }
  }

  public getParentCompanyName() {
    this.spinner.show();
    this.scoreCardService.getParentCompany().subscribe((res: any) => {
      this.spinner.hide();
      this.parentNames = res.data.map(item => ({
        name: item,
        value: item,
      }));
      if (this.type === USERTYPE.SUPPLIER_USER) {
        this.parents = this.parentNames;
        this.getGSL(this.parents);
        this.defaultParent = true;
      }
    });
  }

  public async getGSL(value) {
    if (value.length === 0) {
      this.gslNumbers = [];
      this.parentNameGSLs = [];
      return;
    }
    if (this.type === USERTYPE.SUPPLIER_USER) {
      this.gslNumbers = this.profileUser.gslInfos.map(item => ({
        name: `${item.supplierName}/${item.gslNumber}`,
        value: item.gslNumber,
        parentName: item.parentCompanyName,
        suplierName: `${item.supplierName}/${item.gslNumber}`
      }));
      this.parentNameGSLs = this.gslNumbers;
      this.getDataFilter();
    } else {
      this.spinner.show();
      const data = value.slice();
      if (data[0] === 'All') {
        data.shift();
      }
      this.parents = data;
      const resp: any = await this.scoreCardService.getGSLsByParent(this.parents.map(item => item.value)).toPromise();
      this.spinner.hide();
      this.gslNumbers = resp.data.map(item => ({
        name: `${item.s}/${item.g}`,
        value: item.g,
        parentName: item.p,
        suplierName: `${item.s}/${item.g}`
      }));
    }
    // remove gsl filter by parent
    if (this.parentNameGSLs.length > 0) {
      const gslNumbers = [];
      this.parents.forEach(item => {
        gslNumbers.push(...this.parentNameGSLs.filter(gsl => gsl.parentName === item.value));
      });
      this.parentNameGSLs = gslNumbers;
    }
    this.cd.detectChanges();
  }

  public chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.dateTime.value;
    ctrlValue.year(normalizedYear.year());
    this.dateTime.setValue(ctrlValue);
  }

  public chosenMonthHandler(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>) {
    const ctrlValue = this.dateTime.value;
    ctrlValue.month(normalizedMonth.month());
    this.dateTime.setValue(ctrlValue);
    datepicker.close();
    this.getDataFilter();
  }

  public initValueTable(object: any, field) {
    return this.isObject(object[field]) ? (this.isNumber(object[field].sc) && field !== 'perfSustain') ? object[field].sc : object[field].nm : object[field];
  }

  private downloadRowData(model) {
    if (this.isTableauView) {
      this.spinner.show();
      this.scoreCardService.downloadRawData(model).subscribe(res => {
        this.spinner.hide();
        let fileName = (model.considerParentSupplier ? this.listParentName[this.index].name : model.gsl) + '_RawData';
        fileName = fileName.replace(/[&\/\\#,+()$~%.'":*?<>{}\s]/g, '');
        this.saveExcelFile.saveAsExcelFile(res, fileName);
      })
    }
  }

  downloadInternalRawData() {
    if (this.resultFilter.value.commodities.length > 0) { // check commodity or region or location values existed
      const model = new INTERNALREPORT([]);
      model.convertToModel(this.resultFilter.value);
      this.spinner.show();
      this.scoreCardService.countPhase(model).subscribe(res => {
        this.spinner.hide();
        const phase = res.data;
        this.processDownload(phase, model);
      });
    }
  }

  downloadBotReport() {
    if (this.resultFilter.value.commodities.length > 0) { // check commodity or region or location values existed
      const model = new INTERNALREPORT([]);
      model.convertToModel(this.resultFilter.value);
      this.spinner.show();
      this.scoreCardService.downloadBotReport(model).subscribe(res => {
        this.spinner.hide();
        const fileName = 'Bid List - Bot Report';
        this.saveExcelFile.saveAsExcelFile(res, fileName);
      });
    }
  }

  private processDownload(phase, model) {
    const dialogRef = this.dialog.open(ProcessDownloadFilesComponent, {
      width: '800px',
      maxHeight: '300px',
      disableClose: true,
      data: {
        phase: phase,
        model: model
      }
    });
  }

  private async getDataFilter() {
    if (this.parentNameGSLs.length > 0 && this.timeRange && this.dateTime) {
      const date = new Date(this.dateTime.value.format()).getTime();
      // const gsl = Object.values(this.parentNameGSLs).map(item => item.value);
      const gsl = this.parentNameGSLs.map(item => item.value);
      this.spinner.show();
      const result = await forkJoin(
        this.scoreCardService.getCommodities(gsl, this.timeRange, date, VIEW_TYPE.TABLEAU),
        this.scoreCardService.getLocationsAndRegions(gsl, this.timeRange, date, VIEW_TYPE.TABLEAU)
      ).toPromise();
      this.spinner.hide();
      // mapping commodities
      const commodityArray = result[0].data.map(item => {
        const object = {
          name: item.name,
          value: item.name
        };
        return object;
      });
      this.listCommodity = commodityArray;
      this.commodities = this.listCommodity;

      // mapping location-region
      if (result[1].data.length > 0) {
        this.groupLocationAndRegion = result[1].data;
      } else {
        this.groupLocationAndRegion = [];
      }

      // map array object locations
      const locationArray = this.groupLocationAndRegion.map(item => item.location).filter(this.onlyUnique)
        .map(item => ({ name: item, value: item }));
      this.listLocation = locationArray;
      this.locations = this.listLocation;

      // map array object region
      const regionArray = this.groupLocationAndRegion.map(item => item.region).filter(this.onlyUnique)
        .map(item => ({ name: item, value: item }));
      this.listRegion = regionArray;
      this.regions = this.listRegion;

      this.cd.detectChanges();
    }
  }

  onApplyClick() {
    if (this.parentNameGSLs.length === 0 || this.commodities.length === 0 || this.regions.length === 0
      || this.locations.length === 0) {
      return;
    }
    // set resultFilter when click Apply button
    if (this.type === USERTYPE.INTERNAL_USER) {
      this.resultFilter = {
        value: {
          parents: this.parents,
          gsl: this.parentNameGSLs,
          locations: this.locations,
          commodities: this.commodities,
          regions: this.regions,
          considerParentSupplier: this.considerParentSupplier,
          timeRange: this.timeRange,
          poReceiptMonth: new Date(this.dateTime.value.format()).getTime(),
          scorecardClass: this.resultFilter ? this.resultFilter.value.scorecardClass : SCORECARD_CLASS,
          considerSupplierCommodity: this.resultFilter ? this.resultFilter.value.considerSupplierCommodity : false
        } as INTERNALREPORT,
        data: {
          listCommodity: this.listCommodity,
          listLocation: this.listLocation,
          listRegion: this.listRegion,
          listParentSupplierGSL: this.listParentSupplierGSL,
          parentName: this.parentNames,
          GSLs: this.gslNumbers,
          scorecardClasses: SCORECARD_CLASS,
          minor: this.resultFilter.data.minor,
        }
      };
    }

    // get value from control for model
    this.isConsider = this.considerParentSupplier.valueOf();
    // this.parentNameGSLsCopy = Object.values(this.parentNameGSLs).slice();
    this.parentsCopy = this.parents.slice().map(item => item.value);
    this.parentNameGSLsCopy = this.parentNameGSLs.slice();
    this.locationsCopy = this.locations.slice().map(item => item.value);
    this.commoditiesCopy = this.commodities.slice().map(item => item.value);
    this.regionsCopy = this.regions.slice().map(item => item.value);
    this.dateTimeCopy = new Date(this.dateTime.value.format()).getTime();
    this.timeRangeCopy = this.timeRange.slice();

    this.listParentName = this.parentsCopy.slice();
    this.index = 0;

    // config for parentName right
    if (this.isConsider) {

      // get gsl numbers with parent name
      this.listParentName = this.listParentName.map(item => {
        // tslint:disable-next-line: no-shadowed-variable
        const array = [];
        this.parentNameGSLsCopy.forEach(el => {
          if (el.parentName === item) {
            array.push(el.value);
          }
        });
        const object = {
          name: item,
          value: array
        };
        return object;
      });
      this.listParentName = this.listParentName.filter(item => item.value.length > 0);
    } else {
      this.listParentName = this.parentNameGSLsCopy.map(item => ({ name: item.suplierName, value: [item.value] }));
    }

    const model = new ExternalReport({
      considerParentSupplier: this.isConsider,
      gsl: this.listParentName.length > 0 ? this.listParentName[this.index].value : this.listParentName,
      timeRange: this.timeRange,
      poReceiptMonth: this.dateTimeCopy,
      commodities: this.commoditiesCopy,
      locations: this.locationsCopy,
      regions: this.regionsCopy
    });

    this.query(model);
  }

  public onChangeSupplier(isDownload?: boolean) {
    this.index = this.parentNameModel;
    const model = new ExternalReport({
      considerParentSupplier: this.isConsider,
      gsl: this.listParentName[this.index].value,
      timeRange: this.timeRange,
      poReceiptMonth: this.dateTimeCopy,
      commodities: this.commoditiesCopy,
      locations: this.locationsCopy,
      regions: this.regionsCopy
    });
    if (isDownload) {
      this.downloadRowData(model);
    } else {
      this.query(model);
    }
  }

  public onChangeRequestOption(event: RequestOption) {
    this.requestOption = event;
    this.queryInternalReport(this.resultFilter.value);
  }

  public initialRequestOption() {
    this.requestOption.pagingOptions.totalPages = 0;
    this.requestOption.pagingOptions.numberOfElements = 0;
  }

  public loadDataTable(goToFirstPage?: boolean) {
    if (goToFirstPage) {
      this.requestOption.pagingOptions = new Paging(this.requestOption.pagingOptions.size);
      this.sort.active = this.sort.active || 'ytdspend';
      this.sort.direction = this.sort.direction || 'desc';

      this.requestOption.pagingOptions.sort.sortBy = this.sort && this.sort.direction ? this.sort.active : undefined;
      this.requestOption.pagingOptions.sort.sortOrder = this.sort && this.sort.direction ? this.sort.direction : undefined;
      this.cd.detectChanges();
      this.initialRequestOption();
    }
    this.queryInternalReport(this.resultFilter.value);
  }

  private query(model) {
    // list parent name
    this.spinner.show();
    this.scoreCardService.query(model, this.type).subscribe(res => {
      this.spinner.hide();
      if (Object.values(res.data).length > 0) {
        this.listScorecardInfo = res.data;
        this.totalSpend = this.listScorecardInfo.htp ? '$' + this.formatTotalSpend(this.listScorecardInfo.htp) : '$0';

        // mapping performance value
        this.updatePerformanceData(this.performanceData, res.data, this.isConsider, this.listParentName, this.index);
        this.updatePerformanceData(this.performanceSustainData, res.data, this.isConsider, this.listParentName, this.index);
        this.updatePerformanceData(this.performanceQualityData, res.data, this.isConsider, this.listParentName, this.index);
        this.updatePerformanceData(this.performanceDeliveryData, res.data, this.isConsider, this.listParentName, this.index);
        this.updatePerformanceData(this.performanceCostData, res.data, this.isConsider, this.listParentName, this.index);

        // mapping relationship value
        this.relationshipData.forEach((item: RelationShipSettings) => {
          if (res.data.relationship[item.name] !== undefined) {
            item.v = res.data.totalSpend === 0 && res.data.relationship[item.name].v === 0 ? '' : res.data.relationship[item.name].v;
            item.clr = res.data.relationship[item.name].clr;
            // item.m = res.data.relationship[item.name].m;
            switch (item.name) {
              case 'relsCI':
                item.m = 25;
                break;
              case 'relsTI':
                item.m = 25;
                break;
              case 'relsR':
                item.m = 20;
                break;
              case 'relsCF':
                item.m = 20;
                break;
              default:
                item.m = 30;
            }
            item.n = res.data.relationship[item.name].n;
            item.b = res.data.relationship[item.name].b;
            item.e = res.data.relationship[item.name].e;
            item.gaugeData = {
              name: item.name,
              v: item.v? item.v : 0.0,
              type: item.type,
              unit: '',
              n: 0,
              // m: 30
              m: item.m,
              startLetter: 'Q',
              className: (() => 'class1'),
              color: item.clr,
              b: item.b,
              e: item.e
            };
          } else {
            item.v = '';
            item.clr = '';
          }
        });
        this.parentNameModel = this.index;

        // relsCI: 'Law & Regulation', - 25
        // relsTI: 'Drive Innovation', - 20
        // relsR: 'Customer Focus', - 10
        // relsCF: 'Lean Mindset', - 20

        // Law & Regulation = 25
        // Drive Innovation = 25
        // Customer Focus = 20
        // Lean Mindset = 20

        // mapping segmentation value
        if (this.type === USERTYPE.INTERNAL_USER) {
          this.segmentation = this.segmentation.map(item => {
            item.value = res.data.segmentation[item.name];
            if (item.maxScore) {
              item.maxScore.value = res.data.segmentation[item.maxScore.name];
            }
            return item;
          });
        }

        this.cd.detectChanges();

      }
    });
  }

  public getLastUpdate() {
    this.scoreCardService.getLastUpdate().subscribe(res => {
      this.lastUpdate = new Date(res.data).toLocaleString();
      this.cd.detectChanges();
    });
  }

  public getReceiptDate() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();
    const today = new Date().getDate();
    const lastDayOfMonth = new Date(year, month + 1, 0);
    if (today === lastDayOfMonth.getDate()) {
      this.resultFilter.value.poReceiptMonth = new Date().getTime();
    } else {
      if (month === 12) {
        this.resultFilter.value.poReceiptMonth = new Date(year - 1, 12, 0).getTime();
      } else {
        this.resultFilter.value.poReceiptMonth = new Date(year, month, 0).getTime();
      }
    }
    this.poReceiptMonthDefault = this.resultFilter.value.poReceiptMonth;
    this.dateTime = new FormControl(moment(this.resultFilter.value.poReceiptMonth));
  }

  public async getHeaderValue(model) {
    const result: any = await this.scoreCardService.getHeaderValue(model).toPromise();
    //console.log(result);
    this.totalScore = result.data.averageScore;
  }

  public checkDisabled() {
    if (this.parentNameGSLs.length === 0 || this.commodities.length === 0 || this.locations.length === 0
      || this.regions.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  public checkDisabledRawTableau() {
    if (this.parentNameGSLs.length === 0
      || this.commodities.length === 0
      || this.locations.length === 0
      || this.regions.length === 0
      || this.listParentName.length === 0
      || (this.parentNameModel === undefined)) {
      return true;
    } else {
      return false;
    }
  }

  public openDialogFilter() {
    const dialogRef = this.dialog.open(InternalFilterDialogComponent, {
      maxWidth: '60%',
      maxHeight: '600px',
      disableClose: true,
      data: {
        filteredData: this.resultFilter,
        firstTime: this.firstTime || false,
        poReceiptMonth: this.poReceiptMonthDefault
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      if (typeof (res) === 'object') {
        this.firstTime = false;
        this.resultFilter = res;

        this.tableSettings.forEach(item => {
          if (item.displayedColumns === 'commodity') {
            if (this.resultFilter.value.considerSupplierCommodity) {
              item.show = true;
            } else {
              item.show = false;
            }
          }
        });
        this.displayColumns = this.tableSettings.filter(item => item.show).map(item => item.displayedColumns);
        this.loadDataTable(true);
      }
    });
  }

  public getParentCompanyNameAndMinorComponent() {
    this.spinner.show();
    forkJoin([
      this.scoreCardService.getParentCompany(),
      this.scoreCardService.getMinorComponent()
    ]).subscribe(
      async ([parent, minor]) => {

        // get parent names for tableau view
        this.parentNames = parent.data.map(item => ({
          name: item,
          value: item,
        }));
        if (this.type === USERTYPE.SUPPLIER_USER) {
          this.parents = this.parentNames;
          this.getGSL(this.parents);
          this.defaultParent = true;
        }

        this.resultFilter.data.parentName = this.parentNames;
        // this.resultFilter.value.parents = this.parentNames;
        this.resultFilter.data.minor = minor.data.map(item => ({ value: item, name: item }));
        setTimeout(() => {
          this.spinner.hide();
        }, 1000);
      });
  }

  public exportExcel() {
    if (this.resultFilter.value.commodities.length > 0) { // check commodity or region or location values existed
      const model = new INTERNALREPORT([]);
      model.convertToModel(this.resultFilter.value);
      this.spinner.show();
      this.scoreCardService.exportExcel(model).subscribe(res => {
        this.spinner.hide();
        const fileName = 'TableView';
        this.saveExcelFile.saveAsExcelFile(res, fileName);
      });
    }
  }

  public openSegmentationMatrix() {
    if (this.resultFilter.value.commodities.length > 0) {
      const model = new INTERNALREPORT([]);
      model.convertToModel(this.resultFilter.value);
      this.spinner.show();
      this.scoreCardService.getSegmentationMatrixData(model).subscribe((res: any) => {
        this.spinner.hide();
        if (res.data) {
          const height = window.innerHeight;
          const dialog = this.dialog.open(SegmentMatrixChartComponent, {
            width: height > 900 ? '800px' : '630px',
            height: height > 900 ? '700px' : '530px',
            data: res.data
          });
        }
      });
    }
  }

  public openSpiderChart() {
    if (this.resultFilter.value.commodities.length > 0) {
      const model = new INTERNALREPORT([]);
      model.convertToModel(this.resultFilter.value);
      const height = window.innerHeight;
      this.spinner.show();
      this.scoreCardService.getSpiderChart(model).subscribe(res => {
        if (res) {
          this.spinner.hide();
          const dialog = this.dialog.open(SpiderChartComponent, {
            width: height > 900 ? '40vw' : '50vw',
            height: 'auto',
            data: res.data
          });
        }
      }, () => this.spinner.hide());
    }
  }

  public showLegend() {
    const dialogRef = this.dialog.open(LegendDialogComponent, {
      maxWidth: '40vw',
      height: 'auto'
    });
  }

  public backToTableau() {
    this.defaultALL = false;
    this.isTableauView = !this.isTableauView;
    if (this.resultFilter) {
      if (this.isTableauView) {
        this.considerParentSupplier = this.resultFilter.value.considerParentSupplier;
        this.timeRange = this.resultFilter.value.timeRange;
        this.dateTime = new FormControl(moment(this.resultFilter.value.poReceiptMonth));
        if (this.resultFilter.value.gsl.length > 0) {
          this.parents = this.resultFilter.value.parents.length > 1 ? [this.resultFilter.value.parents[0]] : this.resultFilter.value.parents;
          this.parentNameGSLs = this.resultFilter.value.parents.length > 1 ? this.resultFilter.value.gsl.filter(gsl => gsl.parentName === this.parents[0].name)
            : this.resultFilter.value.gsl;
          this.commodities = this.resultFilter.value.commodities;
          this.regions = this.resultFilter.value.regions;
          this.locations = this.resultFilter.value.locations;
          this.listCommodity = this.resultFilter.data.listCommodity || [];
          this.listLocation = this.resultFilter.data.listLocation || [];
          this.listRegion = this.resultFilter.data.listRegion || [];
          this.listParentSupplierGSL = this.resultFilter.value.parents.length > 1 ? this.resultFilter.data.GSLs.filter(gsl => gsl.parentName === this.parents[0].name)
            : this.resultFilter.data.listParentSupplierGSL;
          this.parentNames = this.resultFilter.data.parentName;
          this.gslNumbers = this.resultFilter.data.GSLs.length > 0 ? this.resultFilter.data.GSLs.filter(item => item.parentName === this.parents[0].name) : [];
          this.onApplyClick();
        } else {
          this.parentNameGSLs = [];
          this.commodities = [];
          this.regions = [];
          this.locations = [];
          this.listCommodity = [];
          this.listLocation = [];
          this.listRegion = [];
          this.listParentSupplierGSL = [];
        }
      } else {
        this.loadDataTable(true);
      }
    }
  }

  public showHideDetail(name, value) {
    this.tableSettings.find(item => item.displayedColumns === name).showDetail = value;
    this.tableSettings.filter(item => item.parentName === name).forEach(el => {
      el.show = value;
    });
    this.displayColumns = this.tableSettings.filter(item => item.show).map(item => item.displayedColumns);
  }

  public isObject(item) {
    return typeof (item) === 'object' ? true : false;
  }

  public isNumber(item) {
    return typeof (item) === 'number' ? true : false;
  }

  public isBoolean(item) {
    return typeof (item) === 'boolean' ? true : false;
  }

  public downloadGuideLine() {
    let type = '';
    if (!this.isTableauView) {
      type = 'report-internal';
    } else {
      type = 'report-external';
    }
    this.spinner.show();
    this.scoreCardService.downloadGuildline(type).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        window.open(res.data);
      }
    });
  }

  public sortHeader(sort: Sort) {
    if (this.sortTimeoutInstance) {
      clearTimeout(this.sortTimeoutInstance);
    }
    this.sortTimeoutInstance = setTimeout(() => {
      this.requestOption.pagingOptions.sort.sortBy = sort.active;
      this.requestOption.pagingOptions.sort.sortOrder = sort.direction;
      this.queryInternalReport(this.resultFilter.value);
    }, 500);
  }

  public openTrendingChart(fieldName, value, supplierName, gslNumber) {
    const dialogRef = this.dialog.open(TrendingChardDialogComponent, {
      maxWidth: '1200px',
      maxHeight: '600px',
      disableClose: false,
      data: {
        name: fieldName,
        data: value,
        supplier: supplierName,
        gsl: gslNumber
      }
    });
  }

  public async downloadSupplierPrice(raw, name) {
    if (name === 'ytdCostOutSupplierDeflation' || name === 'ytdSupplierDeflation') {
      const data = this.resultFilter.value;
      const model = new INTERNALREPORT({
        considerParentSupplier: data.considerParentSupplier,
        considerSupplierCommodity: data.considerSupplierCommodity,
        gsl: raw.supplierGsl ? [raw.supplierGsl] : data.gsl.filter((item) => item.parentName === raw.parentCompany)
                                                              .map((item: MatSelectModel) => item.value),
        timeRange: (name === 'ytdSupplierDeflation') ? 1 : data.timeRange,
        poReceiptMonth: data.poReceiptMonth,
        commodities: raw.commodity ? [raw.commodity] : data.commodities.map((item: MatSelectModel) => item.value),
        locations: data.locations.map((item: MatSelectModel) => item.value),
        regions: data.regions.map((item: MatSelectModel) => item.value),
        scorecardClass: data.scorecardClass.map((item: MatSelectModel) => item.value),
        parents: !raw.supplierGsl ? [raw.parentCompany] : [],
        commercialClass: data.commercialClass.map((item: MatSelectModel) => item.value),
        considerInternalExternal: data.considerInternalExternal.map((item: MatSelectModel) => item.value),
        coe: data.coe.map((item: MatSelectModel) => item.value),
        considerComplete: data.considerComplete.map((item: MatSelectModel) => item.value),
        minorComponent: data.minorComponent.map((item: MatSelectModel) => item.value),
      });

      await this.downloadSupPrice(model);
      await this.downloadRawSupplierPrice(model);
    }
  }

  public downloadOTDPromisedDate() {
    if (!this.resultFilter.value.considerSupplierCommodity) {
      const model = new INTERNALREPORT([]);
      model.convertToModel(this.resultFilter.value);
      this.spinner.show();
      this.scoreCardService.downloadOTDPromisedDate(model).subscribe(res => {
        this.spinner.hide();
        let fileName = 'OTD_Promised_Date';
        fileName = fileName.replace(/[&\/\\#,+()$~%.'":*?<>{}\s]/g, '');
        this.saveExcelFile.saveAsExcelFile(res, fileName);
      });
    } else {
      this.toastr.error(MESSAGE_TOAST.DOWNLOAD_OTD);
    }
  }

  public downloadOTDNeeds() {
    if (!this.resultFilter.value.considerSupplierCommodity) {
      const model = new INTERNALREPORT([]);
      model.convertToModel(this.resultFilter.value);
      this.spinner.show();
      this.scoreCardService.downloadOTDNeeds(model).subscribe(res => {
        this.spinner.hide();
        let fileName = 'OTD_Needs';
        fileName = fileName.replace(/[&\/\\#,+()$~%.'":*?<>{}\s]/g, '');
        this.saveExcelFile.saveAsExcelFile(res, fileName);
      });
    } else {
      this.toastr.error(MESSAGE_TOAST.DOWNLOAD_OTD);
    }
  }

  public showHidePerfKpi() {
    this.isShowKperKpis = !this.isShowKperKpis;
  }

  private async downloadRawSupplierPrice(model) {
    this.spinner.show();
    const result = await this.scoreCardService.downloadRawSupplierPrice(model).toPromise();
    this.spinner.hide();
    let fileName = 'Supplier_Price_RawData';
    fileName = fileName.replace(/[&\/\\#,+()$~%.'":*?<>{}\s]/g, '');
    this.saveExcelFile.saveAsExcelFile(result, fileName);
  }

  private async downloadSupPrice(model) {
    this.spinner.show();
    const result = await this.scoreCardService.downloadSupplierPrice(model).toPromise();
    this.spinner.hide();
    let fileName = 'Supplier_Price';
    fileName = fileName.replace(/[&\/\\#,+()$~%.'":*?<>{}\s]/g, '');
    this.saveExcelFile.saveAsExcelFile(result, fileName);
  }

  public onGoEcovadis() {
    window.open('https://idp.ecovadis-survey.com/');
  }

  private fintIndexComma(str: string) {
    return str.search(',');
  }

  private formatTotalSpend(value) {
    const formatNumber = formatter.format(value);
    if (formatNumber.split(',').length > 2) {
      return (formatNumber.slice(0, this.fintIndexComma(formatNumber) + 3) + 'M').replace('$', '');
    }
    if (formatNumber.split(',').length > 1) {
      return (formatNumber.slice(0, this.fintIndexComma(formatNumber)) + 'K').replace('$', '');
    }
    return this.totalSpend = value;
  }

  private onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  private async queryInternalReport(data: INTERNALREPORT) {

    this.resultFilter.value = new INTERNALREPORT(data, this.resultFilter.data.minor);

    const model = new INTERNALREPORT(data, this.resultFilter.data.minor);
    model.convertToModel(this.resultFilter.value);

    this.spinner.show();
    this.scoreCardService.queryInternalReport(model, this.requestOption).subscribe(async res => {
      this.spinner.hide();
      if (res.data.content.length > 0) {
        this.tableData = res.data.content;
        this.dataSource.data = [];
        const rq: RequestOption = { ...this.requestOption };
        rq.pagingOptions.totalPages = res.data.totalPages;
        rq.pagingOptions.numberOfElements = res.data.numberOfElements;
        rq.pagingOptions.totalElements = res.data.totalElements;
        this.totalResults = res.data.totalElements;
        this.requestOption = rq;
        await this.getHeaderValue(model);

        // if consider parent = yes
        if (this.resultFilter.value.considerParentSupplier) {
          const column = Object.keys(InternalReportKey);
          for (const item of this.tableData) {
            item['kpi'].forEach((el, index) => {
              this.dataSource.data = [
                ...this.dataSource.data,
                new TableView(column.reduce((a, b) => ({ // new a table record
                  ...a, [b]: this.resultFilter.value.considerSupplierCommodity && (b === 'commerCls' || b === 'commerClsGap' || b === 'segmentCls')
                    ? el[b] : item[b] ? item[b] : el[b]
                }), {
                  rowSpanParent: this.resultFilter.value.considerSupplierCommodity ? 1 :
                    index === 0 ? item['kpi'].length : 0, isShow: false, // set rowSpan parent company column
                  rowSpanSupplier: this.resultFilter.value.considerSupplierCommodity ? 1 :
                    index === 0 ? item['kpi'].length : 0, // set rowSpan gsl number column
                })),
              ] as TableView[];
            });
          }
        } else { // if consider parent = no
          const column = Object.keys(InternalReportKey);
          this.tableData[0]['gsl'].forEach((el) => {
            el.kpi.forEach((kp, index) => {
              this.dataSource.data = [
                ...this.dataSource.data,
                new TableView(column.reduce((a, b) => ({  // new a table record
                  ...a, [b]: this.resultFilter.value.considerSupplierCommodity && (b === 'commerCls' || b === 'commerClsGap' || b === 'segmentCls')
                    ? kp[b] : el[b] ? el[b] : kp[b]
                }),
                  {
                    rowSpanParent: this.resultFilter.value.considerSupplierCommodity ? 1 : index === 0 ? el.kpi.length : 0, isShow: false,
                    rowSpanSupplier: this.resultFilter.value.considerSupplierCommodity ? 1 : index === 0 ? el.kpi.length : 0,
                  })),
              ] as TableView[];
            });
          });
        }

        // format pySpend and ytdSpend
        this.dataSource.data = this.dataSource.data.map(item => {
          item.pyspend.nm = this.formatTotalSpend(item.pyspend.nm);
          item.ytdspend.nm = this.formatTotalSpend(item.ytdspend.nm);
          return item;
        });
      } else {
        this.dataSource.data = [];
        this.totalResults = 0;
        this.cd.detectChanges();
      }

    });
  }

  public hideChildren(isShow, parentCompany) {
    if (!isShow) {
      // hide detail
      const parent = this.tableData.filter(gsl => gsl.com === parentCompany)[0];
      const arrayTemp = this.dataSource.data.filter((item: TableView) => item.parentCompany !== parentCompany
        || typeof (item.isShow) === 'boolean');
      let index = 0;
      this.dataSource.data = arrayTemp.map((item: TableView) => {
        if (item.parentCompany === parentCompany) {
          item.rowSpanParent = index === 0 ? parent.kpi.length : 0;
          item.rowSpanParent = index === 0 ? parent.kpi.length : 0;
          index = index === 0 ? index + 1 : index;
          item.isShow = false;
        }
        return item;
      });

    } else {
      // show detail
      let index1 = 0;
      const arrayTemp = this.dataSource.data.reduce((a, b: TableView) => {
        const newArray = [...a, b];
        if (b.parentCompany === parentCompany && typeof (b.isShow) === 'boolean') {
          const parent = this.tableData.filter(gsl => gsl.com === parentCompany)[0];
          if (index1 === 0) {  // set rowSpan parent company column and isShow
            b.isShow = true;
            parent.gsl.forEach(el => b.rowSpanParent += el.kpi.length);
          }
          while (index1 !== parent.kpi.length - 1) {
            index1++;
            return newArray;
          }
          const column = Object.keys(InternalReportKey);
          parent.gsl.forEach(gsl => {
            newArray.push(...gsl.kpi.map((kp, index) => {
              return new TableView(column.reduce((ax, bx) => ({ ...ax, [bx]: bx === 'sup' || bx === 'com' || bx === 'gslNumber' ? gsl[bx] : kp[bx] }),
                { rowSpanSupplier: index === 0 ? gsl.kpi.length : 0, rowSpanParent: 0 }));
            }));
          });
        }
        return newArray;
      }, []);
      this.dataSource.data = arrayTemp.map(item => {
        item.pyspend.nm = typeof (item['pyspend'].nm) === 'number' ? this.formatTotalSpend(item.pyspend.nm) : item.pyspend.nm;
        item.ytdspend.nm = typeof (item['ytdspend'].nm) === 'number' ? this.formatTotalSpend(item.ytdspend.nm) : item.ytdspend.nm;
        return item;
      });
    }
  }

  public checkRowSpan(colName, considerCommodity, rowSpanParent, rowSpanSupplier) {
    if (colName === 'parentCompany') {
      return rowSpanParent;
    }
    if ((colName === 'segmentClass' || colName === 'commercialClassGap' || colName === 'commercialClass') && !considerCommodity) {
      return rowSpanParent;
    }
    if (colName === 'supplierName') {
      return rowSpanSupplier;
    }
    return 1;
  }

  public showLowPerformers() {
    if (this.resultFilter.value.commodities.length > 0) {
      const model = new INTERNALREPORT([]);
      model.convertToModel(this.resultFilter.value);
      this.spinner.show();
      this.scoreCardService.getLowPerformers(model).subscribe((res: any) => {
        this.spinner.hide();
        if (res.data) {
          const height = window.innerHeight;
          const dialog = this.dialog.open(LowPerformersComponent, {
            width: '800px',
            height: '650px',
            data: res.data

          });
          dialog.componentInstance.onDownload.subscribe(data => {
            if (data) {
              this.scoreCardService.downloadLowPerformance(model).subscribe(rp => {
                if (rp) {
                  let fileName = 'Low_Performance';
                  fileName = fileName.replace(/[&\/\\#,+()$~%.'":*?<>{}\s]/g, '');
                  this.saveExcelFile.saveAsExcelFile(rp, fileName);
                }
              });
            }
          });
        }
      });
    }
  }

  getTblHeaderPlaceHolderLeft() {
    let commodityItem = this.tableSettings.find(item => item.displayedColumns === 'commodity');
    return this.tblHeaderPlaceHolderLeft + (commodityItem.show ? 1 : 0);
  }

  getTblHeaderPlaceHolderKPI() {
    let perfSustainItem = this.tableSettings.find(item => item.displayedColumns === 'perfSustain');
    let qualityTotalQScoreItem = this.tableSettings.find(item => item.displayedColumns === 'qualityTotalQScore');
    let deliveryOTDPercentPromisedItem = this.tableSettings.find(item => item.displayedColumns === 'deliveryOTDPercentPromised');
    let ytdcostOutPCOItem = this.tableSettings.find(item => item.displayedColumns === 'ytdcostOutPCO');
    return this.tblHeaderPlaceHolderKPI 
      + (perfSustainItem.showDetail ? perfSustainItem.numOfChilds : 0)
      + (qualityTotalQScoreItem.showDetail ? qualityTotalQScoreItem.numOfChilds : 0)
      + (deliveryOTDPercentPromisedItem.showDetail ? deliveryOTDPercentPromisedItem.numOfChilds : 0)
      + (ytdcostOutPCOItem.showDetail ? ytdcostOutPCOItem.numOfChilds : 0);
  }

  getTblHeaderPlaceHolderScoreSegment() {
    let performanceScoreItem = this.tableSettings.find(item => item.displayedColumns === 'performanceScore');
    let relationshipScoreItem = this.tableSettings.find(item => item.displayedColumns === 'relationshipScore');
    return this.tblHeaderPlaceHolderScoreSegment
    + (performanceScoreItem.showDetail ? performanceScoreItem.numOfChilds : 0)
    + (relationshipScoreItem.showDetail ? relationshipScoreItem.numOfChilds : 0);
  }

  showHideKpiGroup() {
    this.isShowKPIGroup = !this.isShowKPIGroup;
    this.tableSettings.filter(item => DISPLAY_KPI_GROUP.includes(item.displayedColumns)
    ).forEach(el => {
      if (el.parentName && this.isShowKPIGroup) {
        el.show = this.tableSettings.find(item => item.displayedColumns === el.parentName).showDetail;
      } else {
        el.show = this.isShowKPIGroup;
      }
    });
    this.displayColumns = this.tableSettings.filter(item => item.show).map(item => item.displayedColumns);
    return this.isShowScoreSegmentGroup;
  }

  showHideScoreSegmentGroup() {
    this.isShowScoreSegmentGroup = !this.isShowScoreSegmentGroup;
    this.tableSettings.filter(item => DISPLAY_SCORING_SEGMENT.includes(item.displayedColumns)
    ).forEach(el => {
      if (el.parentName && this.isShowScoreSegmentGroup) {
        el.show = this.tableSettings.find(item => item.displayedColumns === el.parentName).showDetail;
      } else {
        el.show = this.isShowScoreSegmentGroup;
      }
    });
    this.displayColumns = this.tableSettings.filter(item => item.show).map(item => item.displayedColumns);
    return this.isShowScoreSegmentGroup;
  }

  getOperator(item: KPI) {
    let str = '';
    if (item.exceedOp === 1) {
      str += CONDITION[4];
    } else if (item.exceedOp === 2) {
      str += CONDITION[3];
    } else if (item.exceedOp === 3) {
      str += CONDITION[2];
    } else {
      str += CONDITION[1];
    }
    str += ' ';
    if (item.belowOp === 1) {
      str += CONDITION[4];
    } else if (item.belowOp === 2) {
      str += CONDITION[3];
    } else if (item.belowOp === 3) {
      str += CONDITION[2];
    } else {
      str += CONDITION[1];
    }
    return str;
  }

  updatePerformanceData(
    items: PerformanceSettings[],
    resData: any,
    isConsider: boolean,
    listParentName: any[],
    index: number
  ) {
    items.forEach((item: PerformanceSettings) => {
      if (resData.performance[item.name]) {
        const data = resData.performance[item.name];
        item.n = data.n;
        item.m = data.m;
        item.trend = data.trend;
        item.v = resData.htp === 0 && data.v === 0 ? '' : data.v;
        item.clr = data.clr;
        item.gsl = isConsider
          ? listParentName[index].name
          : listParentName[index].value[0];

        switch (item.name) {
          case 'perfSustain': {
            item.gaugeData = {
              name: 'sustainability',
              v: item.v? item.v : 0.0,
              type: 'Sustainability',
              unit: '',
              n: 0,
              m: 100,
              startLetter: 'S',
              className: (() => 'class1'),
              color: item.clr, // color default is null,
              b: item.n,
              e: item.m
            };
            break;
          }
          case 'perfQyTQS': {
            item.gaugeData = {
              name: 'tqs',
              v: item.v? item.v : 0.0,
              type: 'Quality',
              unit: '%',
              n: 0,
              m: 100,
              startLetter: 'Q',
              className: (() => 'class2'),
              color: item.clr,
              b: item.n,
              e: item.m
            };
            break;
          }
          case 'perfOTDPD': {
            item.gaugeData = {
              name: 'otdpd',
              v: item.v? item.v : 0.0,
              type: 'Delivery',
              unit: '%',
              n: 0,
              m: 100,
              startLetter: 'D',
              className: (() => 'class3'),
              color: item.clr,
              b: item.n,
              e: item.m
            };
            break;
          }
          case 'perfYoYCoSP': {
            item.gaugeData = {
              name: 'yoycosp',
              v: item.v? item.v : 0.0,
              type: 'Cost',
              unit: '%',
              n: -10,
              m: 10,
              startLetter: 'C',
              className: (() => 'class4'),
              color: item.clr,
              b: item.n,
              e: item.m
            };
            break;
          }
        }
      } else {
        item.v = '';
        item.n = 0;
        item.m = 0;
      }
    });
  }
}
